// ══════════════════════════════════════════════════════════════
// COMPASS – Management Company Reducer
// ══════════════════════════════════════════════════════════════
import { createReducer, on } from '@ngrx/store';
import { ManagementCompanyActions } from './management-company.actions';
import { UserActions } from '../user/user.actions';
import { initialManagementCompanyState, ManagementCompanyState } from './management-company.state';

export const managementCompanyReducer = createReducer<ManagementCompanyState>(
  initialManagementCompanyState,

  on(ManagementCompanyActions.loadCompanies, (state): ManagementCompanyState => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ManagementCompanyActions.loadCompaniesSuccess, (state, { companies }): ManagementCompanyState => ({
    ...state,
    companies,
    loading: false,
    error: null,
    selectedCompanyId: state.selectedCompanyId ?? (companies.length > 0 ? companies[0].id ?? null : null),
  })),

  on(ManagementCompanyActions.loadCompaniesFailure, (state, { error }): ManagementCompanyState => ({
    ...state,
    loading: false,
    error,
  })),

  on(ManagementCompanyActions.selectCompany, (state, { companyId }): ManagementCompanyState => ({
    ...state,
    selectedCompanyId: companyId,
    permissionsLoaded: false,
  })),

  on(ManagementCompanyActions.clearCompanies, (): ManagementCompanyState => ({
    ...initialManagementCompanyState,
  })),

  on(ManagementCompanyActions.loadPermissions, (state): ManagementCompanyState => ({
    ...state,
    permissionsLoading: true,
    error: null,
  })),

  on(ManagementCompanyActions.loadPermissionsSuccess, (state): ManagementCompanyState => ({
    ...state,
    permissionsLoading: false,
  })),

  on(ManagementCompanyActions.loadPermissionsFailure, (state, { error }): ManagementCompanyState => ({
    ...state,
    permissionsLoading: false,
    error,
  })),

  on(UserActions.setCompanyPermissions, (state): ManagementCompanyState => ({
    ...state,
    permissionsLoaded: true,
  })),
);
